// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2YZYV","topBar":"App_topBar__3NCa1","sideBar":"App_sideBar__DDFXu"};